import request from '../request'

export function uploadFile(data) {
    return request({
        url: '/common-service/file/upload',
        data,
        method: 'POST',
    })
}

export function uploadOssFile(data, onUploadProgress) {
    return request({
        url: '/common-service/file/oss/upload',
        data,
        method: 'POST',
        onUploadProgress,
    })
}

/**
 * 获取 OSS 上传 STS 凭证及目标路径
 * 从 cosystem-portal 同步过来，本仓暂未启用对应后端，使用前请核对 URL。
 * @param {string[]} fileNames - 待上传的文件名列表
 * @returns {Promise<Object>} key 为文件名，value 为相对路径，并附带 region/accessKeyId/accessKeySecret/securityToken/bucket
 */
export function getUploadToken(fileNames) {
    return request({
        url: '/common-service/file/oss/token',
        method: 'POST',
        data: { fileNames }
    })
}

export function getUploadFileskey(fileNames) {
    return request({
        url: '/common-service/file/sts/fileskey',
        method: 'POST',
        data: { names: fileNames }
    })
}